import React, { useState } from "react";

const ImageGallery = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);

    const images = require.context('../gallery', true);
    const imageList = images.keys().map(image => images(image));

    const openModal = (image) => {
        setSelectedImage(image);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedImage(null);
    };

    return (
        <div className="max-w-[1248px] mx-auto text-center">
            <div>
                {imageList.map((image, index) => (
                    <div
                        key={index}
                        className="cursor-pointer mb-4 p-2"
                        onClick={() => openModal(image)}
                    >
                        <img src={image} alt={`Image ${index}`} />
                    </div>
                ))}
            </div>

            {/* Modal */}
            {isModalOpen && (
                <div onClick={(closeModal)} className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 ">

                    <button
                        className="absolute top-10 right-10 w-9 text-white hover:text-white"
                        onClick={closeModal}
                    >
                        ✖
                    </button>
                    <img
                        src={selectedImage}
                        className="md:w-[30%] sm:w-[40%] w-[80%] object-contain"
                    />

                </div>
            )}
        </div>
    );
};

export default ImageGallery;